import { Query } from "../data/query";
import { Subscription } from "rxjs";
import { TimeRange, TimeRangeType } from "@nrwl/common-lib";
export abstract class QueryEmitter {
  /**
   * Each widget instance must set-up a 'session'. Session object is used by this service
   * to track all queries for that widget.
   */
  abstract generateWidgetSessionId(): string;

  /**
   * Each query is assigned unique UUID. Please use this function to generate sufficiently unique UUIDs
   */
  abstract generateUUID():string;

    /**
     * We want to exploit UUID field by adding more traceability. This method allows to build UUID
     * and add user and widget specific info.
     */
  abstract generateExtendedUUID(viewId:string, instanceId:string):string;

  /**
   *
   * @param widgetSessionId   widget client id (which must be unique/otherwise widgets will get messages, destined to other widgets!)
   * @param key  widget can use the key parameter to register multiple queries
   * @param query the query to be executed on a periodic basis
   * @param callback the method to be invoked periodically with new data set. Important: so far only deltas will come back, you need to take
   * care and concate new data with previously obtained results.
   */
  abstract submitPeriodic(widgetSessionId: string, key:string, query: Query, callback:any):Subscription;
  /**
   * Differently from submitPeriodic method, this method allows execute the query just once. After results are handed over to your callback,
   * all subscriptions will be cancelled/you will get no more data.
   * @param widgetSessionId
   * @param key
   * @param query
   * @param callback
   */
  abstract submitOneTime(widgetSessionId: string, key:string, query: Query, callback:any):Subscription;

  /**
   * Submits data for time range and updates it periodicaly
   * @param widgetSessionId
   * @param key
   * @param query
   * @param callback
   */
  abstract submitPMW(widgetSessionId: string, key:string, query: Query, callback:any):Subscription;

  /**
   * Submits data from setted dateTime till now and updates it periodicaly
   * @param widgetSessionId
   * @param key
   * @param query
   * @param callback
   */
  abstract submitPMS(widgetSessionId: string, key:string, query: Query, callback:any):Subscription;

  /**
   * Submits data between two dates one time.
   * After results are handed over to your callback,
   * all subscriptions will be cancelled/you will get no more data.
   * @param widgetSessionId
   * @param key
   * @param query
   * @param callback
   */
  abstract submitOTFR(widgetSessionId: string, key:string, query: Query, callback:any):Subscription;

  /**
   * Normally, each widget should have a private instance of IQueryEmitter and tell the emitter to destroy
   * all subscription when widget is being destroyed.
   * However some use cases may have shared instance of IQueryEmitter. In this case, when widget is destroyed,
   * it is recommended to pass over uuid - so that emitter instance knows which subscriptions must be destroyed.
   * @param widgetSessionId
   */
  abstract onDestroy(widgetSessionId?:string);

  /**
   * @param data: { uid: string; requestType: "Nitro | Threat | Anomaly" }
   */
  abstract sendCancelQuery(data);

  // choose query based on time range type 
  abstract chooseQuery(type: TimeRangeType, widgetSessionId: string, key:string, query: Query, callback:any): Subscription;
}
